/**
 * The family mark: the Ambos anvil, struck into an ink tile.
 *
 * The anvil is the shared Ambos mark. The slot struck through the top face is
 * this product's own reference, a letter slot, so the mark carries "mail"
 * without setting a second motif beside the anvil. Monochrome by construction:
 * the tile is `currentColor` and the cut is `--paper`, so colour stays
 * available to mean something on the evidence surfaces.
 *
 * Geometry is shared with `public/icon.svg` and `scripts/gen-pwa-icons.mjs`;
 * change one and change all three.
 */
export function Logomark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 32 32" role="img" aria-label="MIME Smith">
      <rect x="1.25" y="1.25" width="29.5" height="29.5" rx="7.5" fill="currentColor" />
      <path
        fillRule="evenodd"
        fill="var(--paper)"
        d="M6.06 11.2 9.63 8.96 25.25 8.96 25.25 13.44 21.1 13.44 20 18.56 23.7 18.56 23.7 22.4 10.24 22.4 10.24 18.56 13.9 18.56 12.8 13.44 9.63 13.44 Z
           M14.75 10.4 20.2 10.4 20.2 12 14.75 12 Z"
      />
    </svg>
  );
}
